module.exports = __webpack_public_path__ + "static/media/benefits-img-5.6226353e.png";